import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/**
 * Logs `FilterOpen` with the opened section's title, the payload the legacy
 * filter drawer sent. Hand it to a Rocco `FiltersProvider` / `Filters` as
 * `onSectionOpen`.
 */
export const useLogFilterOpen = () => {
    const tracker = useTracker();

    return useCallback(
        (sectionTitle: string) => {
            void tracker.log('FilterOpen', {
                url: new URL(window.location.href),
                data: { ExtraData: sectionTitle },
            });
        },
        [tracker],
    );
};
